var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, makeObservable, computed } from 'mobx';
import { message } from 'antd';
import i18n from '../../i18n';
import PushNotificationsModule from '../modules/PushNotificationsModule';
const READ_NOTIFICATIONS_STORAGE_KEY = 'readNotifications';
class NotificationsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pushNotificationModule", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "readUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Promise.resolve()
        });
        Object.defineProperty(this, "isOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "addNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notifications) => {
                this.items.push(...notifications);
            }
        });
        Object.defineProperty(this, "removeNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                this.items = this.items.filter((notification) => notification._id !== notificationId);
            }
        });
        Object.defineProperty(this, "removeNotificationsByType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                this.items = this.items.filter((notification) => notification.type !== type);
            }
        });
        Object.defineProperty(this, "getNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                const notification = this.notifications.find((notification) => notification._id === notificationId);
                if (!notification) {
                    return null;
                }
                return notification;
            }
        });
        Object.defineProperty(this, "clearNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.items = [];
            }
        });
        Object.defineProperty(this, "markAsRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                const notification = this.getNotification(notificationId);
                if (notification && !notification.read) {
                    return this.markNotificationsAsRead([notificationId]);
                }
            }
        });
        Object.defineProperty(this, "markAllAsRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const unreadIds = this.notifications.filter((notification) => !notification.read).map(({ _id }) => _id);
                return this.markNotificationsAsRead(unreadIds);
            }
        });
        Object.defineProperty(this, "markNotificationsAsRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationIds) => {
                const { storage } = this.rootStore;
                const userId = storage.currentUserId;
                // Keep read updates ordered so a slower response cannot undo a later read
                this.readUpdate = this.readUpdate.then(() => __awaiter(this, void 0, void 0, function* () {
                    if (!notificationIds.length ||
                        !userId ||
                        this.rootStore.storage !== storage ||
                        storage.currentUserId !== userId) {
                        return;
                    }
                    const readNotifications = Object.assign({}, storage.getStorageValue(READ_NOTIFICATIONS_STORAGE_KEY));
                    notificationIds.forEach((id) => {
                        readNotifications[id] = true;
                    });
                    yield storage.setStorageData(READ_NOTIFICATIONS_STORAGE_KEY, readNotifications);
                    if (storage.error && this.rootStore.storage === storage && storage.currentUserId === userId) {
                        message.error(i18n.t('notificationReadFailed'));
                    }
                }));
                return this.readUpdate;
            }
        });
        Object.defineProperty(this, "setIsOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isOpen) => {
                this.isOpen = isOpen;
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.pushNotificationModule = new PushNotificationsModule(this);
    }
    get notifications() {
        var _a;
        const readNotifications = (_a = this.rootStore.storage) === null || _a === void 0 ? void 0 : _a.getStorageValue(READ_NOTIFICATIONS_STORAGE_KEY, {});
        return this.items.map((notification) => (Object.assign(Object.assign({}, notification), { read: notification.read || (readNotifications === null || readNotifications === void 0 ? void 0 : readNotifications[notification._id]) === true })));
    }
    get unreadCount() {
        return this.notifications.filter((notification) => !notification.read).length;
    }
}
__decorate([
    observable
], NotificationsStore.prototype, "isOpen", void 0);
__decorate([
    observable
], NotificationsStore.prototype, "items", void 0);
__decorate([
    computed
], NotificationsStore.prototype, "notifications", null);
__decorate([
    computed
], NotificationsStore.prototype, "unreadCount", null);
__decorate([
    action
], NotificationsStore.prototype, "addNotifications", void 0);
__decorate([
    action
], NotificationsStore.prototype, "removeNotification", void 0);
__decorate([
    action
], NotificationsStore.prototype, "removeNotificationsByType", void 0);
__decorate([
    action
], NotificationsStore.prototype, "clearNotifications", void 0);
__decorate([
    action
], NotificationsStore.prototype, "setIsOpen", void 0);
export default NotificationsStore;
